import React from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@heroui/react';

interface PopoverBaseProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | 'right'
    | 'right-start'
    | 'right-end';
  className?: string;
  overrideDefaultStyles?: boolean;
  onClose?: () => void;
}

const PopoverBase: React.FC<PopoverBaseProps> = ({
  trigger,
  children,
  placement = 'bottom',
  className = '',
  overrideDefaultStyles = false,
  onClose,
}) => {
  return (
    <div className="relative">
      <Popover onClose={onClose} placement={placement}>
        <PopoverTrigger>{trigger}</PopoverTrigger>
        <PopoverContent
          className={`${
            overrideDefaultStyles
              ? 'bg-transparent text-black p-0 rounded shadow-none border-none'
              : 'bg-white text-black p-4 rounded shadow-md border border-gray-200'
          } ${className}`}
        >
          {children}
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default PopoverBase;
